module.exports = __webpack_public_path__ + "img/field-level-endzone-gal-9.21a3df84.jpg";